import type { IDirective } from "angular";

import "./IrisityBackgroundWrapper.html";
import "./IrisityBackgroundWrapper.scss";

export class IrisityBackgroundWrapperDirective implements IDirective {
    public transclude: boolean;

    public replace: boolean;

    public restrict: string;
    public bindings: any;

    public templateUrl: string;

    constructor() {
        this.transclude = true;
        this.replace = true;
        this.restrict = "EA";
        this.bindings = {
            aboutReference: "<",
            stateAfterLogin: "<",
        };
        this.templateUrl = "/App/Modules/Auth/Directives/IrisityBackgroundWrapper/IrisityBackgroundWrapper.html";
    }
}
